module.exports = __webpack_public_path__ + "img/loading.addbd92f.svg";